
import React from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface ArticleStatusProps {
  isPublic: boolean;
  onChange: () => void;
}

export function ArticleStatus({ isPublic, onChange }: ArticleStatusProps) {
  return (
    <div className="flex items-center space-x-2">
      <Switch 
        id="isPublic" 
        checked={isPublic} 
        onCheckedChange={onChange} 
      />
      <Label htmlFor="isPublic">Δημόσιο άρθρο</Label>
    </div>
  );
}
